export default __webpack_public_path__ + "static/grenette-bold-italic-pro-dba442f45862dbb469d2b237f4fb39fd.eot";